import { initPostHog } from "@/lib/posthogInit";

initPostHog();
